/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SetUserPasswordRequest model module.
* @module model/SetUserPasswordRequest
* @version 2020-12-7
*/
export default class SetUserPasswordRequest {
    /**
    * Constructs a new <code>SetUserPasswordRequest</code>.
    * パスワード変更リクエスト
    * @alias module:model/SetUserPasswordRequest
    * @class
    * @param newPassword {String} 新パスワード
    */

    constructor(newPassword) {
        
        
        this['newPassword'] = newPassword;
        
    }

    /**
    * Constructs a <code>SetUserPasswordRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SetUserPasswordRequest} obj Optional instance to populate.
    * @return {module:model/SetUserPasswordRequest} The populated <code>SetUserPasswordRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SetUserPasswordRequest();
                        
            
            if (data.hasOwnProperty('oldPassword')) {
                obj['oldPassword'] = ApiClient.convertToType(data['oldPassword'], 'String');
            }
            if (data.hasOwnProperty('newPassword')) {
                obj['newPassword'] = ApiClient.convertToType(data['newPassword'], 'String');
            }
        }
        return obj;
    }

    /**
    * 旧パスワード
    * @member {String} oldPassword
    */
    'oldPassword' = undefined;
    /**
    * 新パスワード
    * @member {String} newPassword
    */
    'newPassword' = undefined;




}
